import { css } from 'styled-components';
import { ThemedFunctor, BreakpointQueryName } from '@doveit/lego';

export const agencies: ThemedFunctor = ({ theme }) => css`
  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
`;
